<template>
  <div id="def1" ref="main" class="container" />
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "HTypeRadarChart",
  props: {
    picCharts: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null, // 接收实例对象
    };
  },
  watch: {
    picCharts(newVal) {
      if (newVal !== "") {
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      if (myChart != null && myChart !== "" && myChart !== undefined) {
        myChart.dispose(); // 销毁
      }
      var Names = [this.picCharts.indicator[3].name, this.picCharts.indicator[3].name, this.picCharts.indicator[3].name, this.picCharts.indicator[3].name];
      var Stu = [
        this.picCharts.radars[0],
        this.picCharts.radars[1],
        this.picCharts.radars[2],
        this.picCharts.radars[3],
      ];
      var Max = [
        this.picCharts.indicator[0].max,
        this.picCharts.indicator[1].max,
        this.picCharts.indicator[2].max,
        this.picCharts.indicator[3].max,
      ];
      var myChart = echarts.init(this.$refs.main);
      // 绘制图表
      var option = {
        tooltip: {},
        backgroundColor: "#fff",
        radar: [
          {
            name: {
              formatter: "{value}",
              textStyle: {
                color: "#666666",
                fontSize: 12,
              },
            },
            axisLine: {
              lineStyle: {
                color: "#d5d5d5",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#ececec",
              },
            },
            splitArea: {
              areaStyle: {
                color: "#fff",
                opacity: 0,
              },
            },
            indicator: [
              {
                text: Names[0],
                max: Max[0],
              },
              {
                text: Names[1],
                max: Max[1],
              },
              {
                text: Names[2],
                max: Max[2],
              },
              {
                text: Names[3],
                max: Max[3],
              },
            ],
            center: ["50%", "50%"],
            radius: 70,
          },
        ],
        series: [
          {
            type: "radar",
            symbolSize: 0,
            areaStyle: {
              color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(137, 190, 252, 0.05)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(81, 137, 248, 0.3)", // 100% 处的颜色
                  },
                ],
              },
            },
            itemStyle: {
              color: "#3964E6",
            },
            data: [
              {
                value: Stu,
                name: "类型",
              },
            ],
          },
        ],
      };

      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 300px;
  // background: skyblue;
}
</style>
